<template>
    <MainContentSearchable title="Listado de avisos de ventas" id="sales-ad" v-model="filters" :meta="loading ? {} : ads.meta" @updated="getSalesAd">
        <template v-slot:header>
            <h3 class="card-title"></h3>
            <div class="card-tools">
                <Button class="m-1" @click="showModal('add-sale-ad')">CREAR AVISO</Button>
                <CrearSaleAdModal :evento_id="evento_id" @close="closeModal"/>
            </div>
        </template>

        <template v-slot:content v-if="!loading && ads">
            <div :class="['table', { 'expanded': ads.data.length <= 3 }]">
                <table :class="['table', { 'expanded': ads.data.length <= 3 }, 'table-hover']">
                    <thead>
                        <tr>
                            <th>Lapso de tiempo</th>
                            <th>Email</th>
                            <th class="text-center">Opciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(ad, index) in ads.data">
                            <tr :key="index">
                                <td>{{ ad.time_lapse | formatear_time_lapse }}</td>
                                <td>
                                    {{ ad.email }}
                                </td>
                                <td class="text-center">
                                    <OpcionesDropdownTableComponent
                                        :lastIndex="ads.data.length > 3 && index >= ads.data.length - 3"
                                        v-bind:options="[
                                            { type: 'action', action:() => showModal('editar-' + ad.id), label: 'Editar'},
                                            { type: 'action', action:() => showModal('borrar-' + ad.id), label: 'Borrar'},
                                        ]"
                                    />
                                </td>
                                <EditarSaleAdModal :ad="ad" :evento_id="evento_id" v-on:close="closeModal"/>
                                <DeleteSaleAdModal :ad_id="ad.id" :evento_id="evento_id" @close="closeModal"/>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </template>
    </MainContentSearchable>

</template>

<script>
    import OpcionesDropdownTableComponent from '@/components/backend/components/OpcionesDropdownTableComponent';
    import MainContentSearchable from '@/components/backend/components/MainContentSearchable';
    import CrearSaleAdModal from "./modals/CrearSaleAdModal";
    import DeleteSaleAdModal from './modals/DeleteSaleAdModal';
    import EditarSaleAdModal from './modals/EditarSaleAdModal';

    export default {
        props: ['evento_id'],
        data() {
            return {
                ads: [],
                filters: {
                    per_page: 10,
                    page: 1,
                    search: '',
                    evento_id: this.evento_id
                },
                fields: [ 
                    { key: 'time_lapse', label: 'Lapso de tiempo'},
                    'email', 
                    { key: 'id', label: 'opciones', class: 'text-center' }
                ],
                loading: true
            }
        },
        created() {
            this.getSalesAd();
        },
        methods: {
            getSalesAd : function() {
                const params = {
                    filters : this.filters,
                    evento_id: this.evento_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.events.sales-ad.index'), params).then(res => {
                    this.ads = res.data;
                    this.loading = false;
                });
            },
            setPage(page) {
                this.filters.page = page;
                this.getSalesAd();
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal, edited) {
                this.$modal.hide(modal);
                if(edited) {
                    this.getSalesAd();
                }
            },
        },
        components: {
            OpcionesDropdownTableComponent, MainContentSearchable, CrearSaleAdModal, DeleteSaleAdModal, EditarSaleAdModal
        }
    }
</script>
<style scoped>
.table {
    overflow: auto;
}

.table.expanded {
    padding-bottom: 150px !important;
}
</style>
